import { Box, CircularProgress, Typography } from "@mui/material";
import { min } from "moment";

export const ChartWithLoader = ({ url, title, loading, show,minHeight=170, minWidth=200,maxWidth=250 }) =>
    show ? (
      <Box
        sx={{
          textAlign: "center",
          position: "relative",
          minWidth: minWidth,
          width : "100%",
          maxWidth : maxWidth,
          minHeight: minHeight,
        }}
      >
        <Typography variant="subtitle1" className="whitespace-nowrap text-ellipsis">
          {title}
        </Typography>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: minHeight,
            }}
          >
            <CircularProgress />
          </Box>
        ) : url ? (
          <img
            src={url}
            alt={title}
            // style={{ width: "225px", maxWidth: "100%" }}
            style={{ width: "100%", height: "auto", maxWidth: "100%" }}
            onError={(e) => (e.target.style.display = "none")}
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: minHeight,
              bgcolor: "#f5f5f5",
            }}
          >
            <Typography variant="body2" color="textSecondary">Chart not found</Typography>
          </Box>
        )}
      </Box>
    ) : null;
